export default function LandingDescriptionCard({ icon, title, description }) {
  return (
    <div className="flex items-center md:flex-col gap-6 md:gap-0 md:text-center">
      <img src={icon} alt="Icon" className="mx-auto md:mb-4 w-12 h-12 md:w-16 md:h-16" />
      <div >
        <h3 className="text-xl font-semibold mb-3">{title}</h3>
        <p className=" text-stone-400">{description}</p>
      </div>
    </div>
  )
};